/// <reference path="../../app.definition.ts" />

// typescript namespace
import angular from 'angular';
export class popUpController {

    static $inject = ["$rootScope", "$uibModalStack", "$scope", "$timeout", "$sce", "$uibModalInstance", "PopUpService"];

    constructor(
        $rootScope,
        $uibModalStack,
        $scope,
        $timeout,
        $sce,
        private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
        private PopUpService
    ) {
        $rootScope.mainShowLoader = false;
        var popUpVm: any = this;
        if (!!PopUpService.status && PopUpService.status == 0) {
            $uibModalStack.dismissAll();
            popUpVm.confirmationMessage = "The session has timed out please login again";

        } else {
            popUpVm.confirmationMessage = $sce.trustAsHtml(PopUpService.confirmationMessage);
        }
        popUpVm.infoMessage = $sce.trustAsHtml(PopUpService.infoMessage);
        popUpVm.yesOption = PopUpService.yesOption;
        popUpVm.noOption = PopUpService.noOption;
        popUpVm.removeCross = PopUpService.removeCross;

        popUpVm.showOptions = PopUpService.showOptions;
        popUpVm.mydate = {};
        popUpVm.endDate = {};
        var d = new Date();
        popUpVm.allOccurrences = false;
        // Data to use in template
        popUpVm.type = PopUpService.type;
        popUpVm.data = PopUpService.data;
        popUpVm.personalMsg = "";
        // signatureEvent is added to check the event of review or continue signing
        popUpVm.cancel = function (signatureEvent) {
            if (popUpVm.type == "confirmationWithMsg" || popUpVm.type == "confirmationWithResponse") {
                $uibModalInstance.close({ "message": popUpVm.personalMsg });
            } else if (popUpVm.type == "signConfirmation") {
                $uibModalInstance.close({ "message": signatureEvent });
            } else {
                $uibModalInstance.close();
            }
        }

        popUpVm.dismiss = () => $uibModalInstance.dismiss();

        popUpVm.close = () => {
            $uibModalInstance.close({ "action": popUpVm.noOption })
        };

        popUpVm.confirmAction = () => {
            if (!popUpVm.showOptions) {
                popUpVm.allOccurrences = true;
            }
            $uibModalInstance.close({ "deleteAllOccurrences": popUpVm.allOccurrences });
        }
    }
}

angular.module('eCareVault.common.popUp')
    .controller('PopUpController', popUpController);
/**
 * Created by szaman on 2/3/2016.
 */
